import { useState } from 'react'
import {
  type RenderRequestServerData,
  ServerServiceImpl,
  type UserAgentString,
} from 'src/lib/services/server-data'

import { type CommonServices, createCommonServices } from '@lib/services'

import { IS_BROWSER, APP_ENV } from '@constants/globals'

import { gnarClient, extendGnarEventsWith } from '../tracking/gnar'
import { isTouchDevice } from '../utils/is-touch'

export type AppInitResult = [CommonServices]

export const useAppInit = (
  requestData?: RenderRequestServerData,
  userAgent?: UserAgentString,
): AppInitResult => {
  const [commonServices] = useState(() => {
    return createCommonServices(() => new ServerServiceImpl(requestData, userAgent))
  })

  if (IS_BROWSER) {
    extendGnarEventsWith({
      deviceType: commonServices.browserService.deviceType,
      isMobile: commonServices.browserService.isMobileOrTablet,
      isTouchDevice: isTouchDevice(),
      os: commonServices.browserService.operatingSystem,
      // TODO: Remove before going live, needed only to test event firing e2e
      // Refer https://grammarly.slack.com/archives/C02270EFMA9/p1758645743671299?thread_ts=1758639264.679989&cid=C02270EFMA9
      env: APP_ENV,
    })

    void gnarClient.getContainerId().catch(_error => {}) // sets cookie early
  }

  return [commonServices]
}
